var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"app":""}},[_c('v-container',{staticClass:"ContainerApp"},[_c('v-expand-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }